/** Tiny compiled-friendly SPA router — no third-party, no compat hooks. */

/**
 * Per-route document titles. Deep loads get these from the prerendered HTML
 * (scripts/prerender.mjs - keep the two in sync); SPA navigation applies
 * them here, since pushState never touches document.title.
 */
const TITLES: Record<string, string> = {
  "/": "JetShake - Introducing..",
  "/how-it-works": "JetShake - How It Works",
  "/philosophy": "JetShake - Philosophy",
};

function syncTitle() {
  document.title = TITLES[getPath()] || TITLES["/"];
}

// navigate() dispatches a PopStateEvent, so one listener covers in-app
// links AND the browser's back/forward buttons. The boot-time call keeps
// SPA-fallback servers (vite dev) honest on deep links; on prerendered
// pages it re-sets the same value.
if (typeof window !== "undefined") {
  window.addEventListener("popstate", syncTitle);
  syncTitle();
}

/** Current path, normalized: no trailing slash (/how-it-works/ === /how-it-works). */
export function getPath() {
  if (typeof window === "undefined") return "/";
  const p = window.location.pathname;
  return p.length > 1 && p.endsWith("/") ? p.slice(0, -1) : p;
}

export function navigate(to: string) {
  if (typeof window === "undefined") return;
  if (to === window.location.pathname) return;
  window.history.pushState(null, "", to);
  window.dispatchEvent(new PopStateEvent("popstate"));
  window.scrollTo(0, 0);
}

/** In-app link: pushState, no full document reload. */
export function Link({
  href,
  className,
  children,
  ...rest
}: {
  href: string;
  className?: string;
  children?: any;
  "aria-label"?: string;
}) {
  const onClick = (e: any) => {
    if (
      e.defaultPrevented ||
      e.button !== 0 ||
      e.metaKey ||
      e.ctrlKey ||
      e.shiftKey ||
      e.altKey
    ) {
      return;
    }
    e.preventDefault();
    navigate(href);
  };

  return (
    <a href={href} className={className} onClick={onClick} {...rest}>
      {children}
    </a>
  );
}
